module.exports = __webpack_public_path__ + "img/demo8.f414d127.jpg";